$(function() {
    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    spOptions = {
    onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
        }
    };

    $('.mask-phone').mask(SPMaskBehavior, spOptions);
    $('.input-peso').mask('0ZZ.0Z', {translation:  {'Z': {pattern: /[0-9]/, optional: true}}});
    $('.input-altura').mask('0ZZ', {translation:  {'Z': {pattern: /[0-9]/, optional: true}}});
});